export const gerenciarAtributos = (processo, dadosSessao, dadosEstrutura) => {
  console.log('Estruturaa', dadosEstrutura)
  var atributos = {
    telefone: dadosEstrutura.telefone,
    estado: dadosEstrutura.estado,
    cidade: dadosEstrutura.cidade,
    logradouroRemetente: dadosEstrutura.logradouro,
    cepRemetente: dadosEstrutura.cep,
    bairroRemetente: dadosEstrutura.bairro,
    numeroRemetente: dadosEstrutura.numero,
    complementoRemetente: dadosEstrutura.complemento || '',
    codigoHierarquia: dadosSessao.codigoHierarquia,
    autor: dadosSessao.nomeUsuario,
    motivo: processo.atributos.motivo,
    numeroProcesso: processo.atributos.numeroProcesso,
    numeroProcessoCompleto: processo.atributos.numeroProcessoCompleto,
    textoComplemento: processo.atributos.textoComplemento || '',
    assunto: processo.atributos.assunto,
    interessados: processo.atributos.interessados,
    tipoProtocolo: processo.atributos.tipoProtocolo,
    dataCriacaoFormatada: processo.atributos.dataCriacaoFormatada,
    dataCriacao: processo.atributos.dataCriacao,
    observacao: processo.atributos.observacao || '',
    telefoneDestinatario: dadosEstrutura.telefone,
    estadoDestinatario: dadosEstrutura.estado || '',
    cidadeDestinatario: dadosEstrutura.cidade
  }

  if (processo.ultimaTramitacao) {
    atributos = {
      ...atributos,
      telefoneRemetente: processo.ultimaTramitacao.atributos.telefoneDestinatario || '',
      estadoRemetente: processo.ultimaTramitacao.atributos.estadoDestinatario || '',
      cidadeRemetente: processo.ultimaTramitacao.atributos.cidadeDestinatario || ''
    }
  }

  return atributos
}
